import classNames from 'classnames';
import { SanityImageType } from '@/types/generic';
import SanityImage from '../atoms/SanityImage';

type SizeType = 'small' | 'medium' | 'big' | 'full';
export type ImageType = SanityImageType & {
  orientation?: 'portrait' | 'landscape';
  size?: SizeType;
  caption?: string;
  showText?: boolean;
  className?: string;
};

const ImageComponent = ({
  orientation = 'landscape',
  size = 'medium',
  caption,
  className,
  alternativeText,
  ...props
}: ImageType) => {
  const sizeClass: Record<typeof size, string[]> = {
    small: [
      'max-lg:col-start-2 col-span-4 grid-cols-4 lg:grid-cols-3 lg:col-span-3',
    ],
    medium: ['max-lg:col-start-2 grid-cols-4 col-span-4'],
    big: ['col-span-6 grid-cols-6'],
    full: ['col-span-full grid-cols-12'],
  };

  const getSizes = (width: number, height: number) =>
    orientation === 'landscape'
      ? { width, height }
      : { width: height, height: width };

  const imageSizes: Record<typeof size, { width: number; height: number }> = {
    small: getSizes(400, 300),
    medium: getSizes(800, 600),
    big: getSizes(600, 450),
    full: getSizes(800, 600),
  };

  return (
    <figure
      className={classNames(
        'grid gap-y-4',
        sizeClass[size],
        caption ? 'grid-rows-[auto_1fr]' : '',
        className
      )}
    >
      <div
        className={classNames(
          'relative rounded-3xl w-full overflow-hidden col-span-full',
          orientation === 'portrait' ? 'aspect-[3/4]' : 'aspect-[4/3]'
        )}
      >
        <SanityImage
          className="w-full h-full"
          // fill
          image={{ ...props, alternativeText }}
          // sizes={imageSizes[size]}
          width={imageSizes[size].width}
          height={imageSizes[size].height}
          // height={orientation === 'landscape' ? 300 : 400}
        />
      </div>
      {caption && (
        <figcaption className="max-w-[394px] lg:ml-auto col-span-full lg:col-span-4 lg:col-end-[-2]">
          {caption}
        </figcaption>
      )}
    </figure>
  );
};

export default ImageComponent;
